import { useEffect, useState, useCallback } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CarteCadeauService from "../../../services/MarketingService/CarteCadeauService";
import { Alert, Snackbar } from "@mui/material";
import DataTableListCarteCadeau from "./DataTableListCarteCadeau";
import CardMagasinhome from "../../../components/homePage/cardMagasinhome";
import DataTableListCarteCadeauDetails from "./DataTableListCarteCadeauDetails";

const CartesCadeauDetails = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");

  const [listCarteCadeaux, setListCarteCadeaux] = useState(null);
  const [carteCadeau, setCarteCadeaux] = useState(null);

  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  const onAddCarteCadeauHandler = () => {
    navigate(`/addCarteCadeau`);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };

  const GetCarteCadeauDetails = useCallback(() => {
    startLoading();
    CarteCadeauService.getCarteCadeauDeatils(
      getCurrentUserId(),
      sessionStorage.getItem("idCartesCadeau")
    )
      .then((response) => {
        if (response.data.success) {
          // console.log(response.data.success.carteCadeau)
          setListCarteCadeaux(response.data.success.carteCadeauClientList);
          setCarteCadeaux(response.data.success.carteCadeau)
          setShowTable(true);
        }
      })
      .catch((e) => {
        console.error("Error fetching gift card details:", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, [getCurrentUserId]);

  useEffect(() => {
    GetCarteCadeauDetails();
  }, [GetCarteCadeauDetails]);



  const shopList = [
    {
      nameShop: "Informations sur les Cartes Cadeau",
      // refShop: "SM-001",

    }
  ];

  const card = [
    { titre: "Chiffre d'Affaires", icon: "fas fa-chart-line", by: "Jour" },
    { titre: "Chiffre d'Affaires", icon: "fas fa-chart-line", by: "Semaine" },

  ];


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="m-3 col-sm-12 d-flex">
        <div className="col-sm-3 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-barcode"></i> {/* Reference icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Réference</span>
              <span className="info-box-number">{carteCadeau?.ref}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-gift"></i> {/* Gift card icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Carte Cadeau</span>
              <span className="info-box-number">{carteCadeau?.name}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-box"></i> {/* Product icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Produit</span>
              <span className="info-box-number">{carteCadeau?.product?.name}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className={`fas ${carteCadeau?.isActive === 1 ? "fa-check-circle" : "fa-times-circle"}`}></i> {/* Status icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Status</span>
              <span className="info-box-number">
                {carteCadeau?.isActive === 1 ? "Active" : "Desactive"}
              </span>
            </div>
          </div>
        </div>
      </section>

      {listCarteCadeaux && Array.isArray(listCarteCadeaux) && <DataTableListCarteCadeauDetails listCarteCadeaux={listCarteCadeaux} />}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(CartesCadeauDetails);
